import { NgIf, AsyncPipe } from '@angular/common'
import { Component, ElementRef } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { RoutingService, TranslatePipe } from '@spartacus/core'
import {
  HamburgerMenuService,
  KeyboardFocusService,
  StorefrontComponent,
  OutletDirective,
  PageTemplateDirective,
  SkipLinkDirective,
  FocusDirective,
  PageLayoutComponent,
  GlobalMessageComponent
} from '@spartacus/storefront'
import { EbBaseSiteService } from '../../features/site-context/services/eb-base-site.service'
import { EbBackToTopButtonComponent } from '../back-to-top-button/eb-back-to-top-button.component'
import { EbNoSalesAreaMessageComponent } from '../no-sales-area-message/eb-no-sales-area-message.component'

@Component({
  selector: 'eb-storefront',
  templateUrl: './eb-storefront.component.html',
  standalone: true,
  imports: [
    OutletDirective,
    PageTemplateDirective,
    SkipLinkDirective,
    FocusDirective,
    PageLayoutComponent,
    NgIf,
    EbNoSalesAreaMessageComponent,
    GlobalMessageComponent,
    RouterOutlet,
    EbBackToTopButtonComponent,
    AsyncPipe,
    TranslatePipe
  ]
})
export class EbStorefrontComponent extends StorefrontComponent {
  constructor(
    hamburgerMenuService: HamburgerMenuService,
    routingService: RoutingService,
    elementRef: ElementRef<HTMLElement>,
    keyboardFocusService: KeyboardFocusService,
    protected baseSiteService: EbBaseSiteService
  ) {
    super(hamburgerMenuService, routingService, elementRef, keyboardFocusService)
  }

  get isModalShown(): boolean {
    return document.getElementsByClassName('modal-open').length > 0
  }
}
